import { observer } from 'mobx-react-lite';
import { Typography } from '@mui/material';
import PublishedDate from '@/components/PublishedDate';
import { useCommentStore } from '../CommentContext';
import { CommentSumaryContainer } from './CommentSummary.styles';

export function CommentsSummary(): JSX.Element {
  const { totalCount, lastComment } = useCommentStore();

  if (totalCount === 0) {
    return (
      <Typography variant="body1" color="grey.200">
        Be the first to share your thoughts
      </Typography>
    );
  }

  const { user, createdAt } = lastComment ?? {};
  const commentsCount = `${totalCount} ${
    totalCount > 1 ? 'comments' : 'comment'
  }`;
  const lastCommenter = `${user?.firstName} ${user?.lastName}`;

  return (
    <>
      <CommentSumaryContainer>
        <Typography variant="body1" fontWeight={{ xs: 'bold', sm: 'bold' }}>
          {commentsCount}
        </Typography>
        <Typography variant="body1" color="grey.200">
          Last activity by {lastCommenter},&nbsp;
          <PublishedDate publishedAt={createdAt} />
        </Typography>
      </CommentSumaryContainer>
    </>
  );
}

export default observer(CommentsSummary);
